import ChatbotImgReaderCase from "./ChatbotImgReaderCase";

export default ChatbotImgReaderCase;
